import Ajax from "Utils/ajax";
export const getAllStaff = (data) => Ajax.post('hr/getAllStaff',data);
export const getSalaryList = (data) => Ajax.post('account/getSalarySlip',data);